import { CapoPlugin } from "/Users/rayyach/Desktop/sites/saveAtCost.co/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];